<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" @close="closeDialog()" @visible-change="onVisible" title="" top="5vh" width="75%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :isForCurrentActiveUser="false"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :showPasswordField="showPasswordField"
          class="p-3"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <el-dialog :visible.sync="topLcrDialogVisibility" @close="lcrDialogClosed" title="" top="5vh" width="75%">
      <dg-select-field
          :control="control"
          :field_span="6"
          :label_span="6"
          :options="divisionsList"
          :translateLabel="false"
          :translateLabels="false"
          @amUpdated="lcrDivisionUpdated"
          field_mark="required"
          label="Division"
          name="division_id"
          rules="required"
          v-if="topLcrDialogVisibility"></dg-select-field>
      <topLcrDestinations :defaultDivision="lcrSelectedDivision" :listForRootAsUserMode="true"
                          :requested_user_id="selectedUserId" :requested_user_profile="selectedUserProfileId"
                          v-if="lcrSelectedDivision"></topLcrDestinations>
    </el-dialog>

    <el-dialog :visible.sync="voipReportAnalysisStatisticDialog" title="" top="2vh" width="90%">
      <voipReportAnalysisStatistic :viewMode="reportAnalysisStatisticViewMode" v-if="voipReportAnalysisStatisticDialog" defaultFilterValue="customer" :defaultFilterOptionValue="selectedCustomerUsername"></voipReportAnalysisStatistic>
    </el-dialog>

    <el-dialog :visible.sync="voipReportAnalysisStatisticRateDialog" title="" top="2vh" width="90%">
      <voipCustomerRates :editLiveTrafficRate="editLiveTrafficRate" :showOnlyNewRates="showOnlyNewRates" :showOnlyFixedRates="showOnlyFixedRates" :customerUserId="customerData.id" :userUsingPrivateRate="userUsingPrivateRate" :userRateStatus="userRateStatus" :customerDisplayName="customerData.display_name" v-if="voipReportAnalysisStatisticRateDialog"></voipCustomerRates>
    </el-dialog>

    <el-dialog :visible.sync="customerRatesBoardDialog" custom-class="bg-light-gray" title="" top="2vh" width="90%">
      <voipCustomerRates :showOnlyNewRates="showOnlyNewRates" :showOnlyFixedRates="showOnlyFixedRates" :customerUserId="customerData.id" :userUsingPrivateRate="userUsingPrivateRate" :userRateStatus="userRateStatus" :customerDisplayName="customerData.display_name" v-if="customerRatesBoardDialog"></voipCustomerRates>
    </el-dialog>
    <el-dialog :visible.sync="showCustomersList" @close="closeDialog()" @visible-change="onVisible"  custom-class="bg-light-gray" title="" top="2vh" width="90%">
      <voipCustomers  v-if="showCustomersList2" :customerUserId="customerData"></voipCustomers>
      </el-dialog>
    <el-dialog :visible.sync="showResellerList" @close="closeDialog()" @visible-change="onVisible"  custom-class="bg-light-gray" title="" top="2vh" width="90%">
      <assignResellerList v-if="showResellerList" :accManagerId="resellerData"></assignResellerList>
      </el-dialog>
    <el-dialog :visible.sync="showVendorList" @close="closeDialog()" @visible-change="onVisible"  custom-class="bg-light-gray" title="" top="2vh" width="90%">
      <assignVendorList v-if="showVendorList"  :accManagerId="vendorData"></assignVendorList>
      </el-dialog>
    <el-dialog :visible.sync="showCDRList" @close="closeDialog()" @visible-change="onVisible"  custom-class="bg-light-gray" title="" top="2vh" width="90%">
      <userCdrList v-if="showCDRList"  :cdrData="cdrData"></userCdrList>
      </el-dialog>

    <el-dialog :visible.sync="setProfitRateDialogVisible" title="" top="5vh" width="75%">
      <setProfileRateForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Set Profit Percent for \'' + selectedUsername +'\''"
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :userId="selectedUserId"
          class="p-3"
          v-if="setProfitRateDialogVisible"></setProfileRateForm>
    </el-dialog>

    <el-dialog :visible.sync="setWorkingRatesDialogVisible" title="" top="5vh" width="75%">
      <setWorkingRates
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Set Working Destinations Rates For \'' + selectedUsername  + '\''"
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :userId="selectedUserId"
          class="p-3"
          v-if="setWorkingRatesDialogVisible"></setWorkingRates>
    </el-dialog>

    <el-dialog :append-to-body="true" :visible.sync="viewUserTestsDialogVisible" custom-class="bg-light-gray" title=""
               top="5vh" width="75%">
      <broadcastHistory
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Broadcast History for ' + selectedUsername "
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :statusId="0"
          :userId="selectedUserId"
          class="p-3"
          v-if="viewUserTestsDialogVisible"></broadcastHistory>
    </el-dialog>

    <app-board style="border-radius: 0; padding: 5px; margin-bottom: 5px">
      <el-row>
        <el-col :span="12">
          Users List
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button @click="createAction" icon="el-icon-plus" size="mini" type="primary">Create</el-button>
        </el-col>
      </el-row>
    </app-board>

    <app-board style="border-radius: 0;padding: 0;margin: 0;padding-top: 5px;">
      <div class="row m-0 p-0" style="height: 70px;">
        <div class="col-12 col-md-3">
          <small>Search</small>
          <dg-text-field
              :field_span="22"
              :label_span="22"
              :liveUpdate="true"
              @amUpdated="userSearchUpdated"
              class="m-0 p-0"
              field_mark=""
              placeholder="search username or display name"></dg-text-field>
        </div>
        <div class="col-12 col-md-3">
          <dg-select-field
              :control="control"
              :field_span="22"
              :label_span="22"
              :options="profilesOptionsList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="filterByProfileUpdated"
              field_mark=""
              label="Filter Profile"
              name="destination"
              placeholder="Filter By Profile"
              rules=""></dg-select-field>
        </div>
        <div class="col-12 col-md-6 mb-1 pt-4">
          <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
        </div>
      </div>
    </app-board>

    <!--    :default-sort="{prop: 'display_name', order: 'descending'}"-->
    <el-table
        :data="tableData"
        border
        cell-class-name="p-1"
        :row-class-name="tableRowClassName"
        style="width: 100%">
      <el-table-column type="expand" class="p-0 m-0" width="30">
        <template slot-scope="props">

          <div class="app-light-silver-background mt-0 pt-0" style="width: calc(100% - 50px);float: right;">
            <h6 class="app-light-silver-background mt-0 p-2 pl-3 text-center p-0">Fusion Info</h6>
            <el-table
                :data="[props.row]"
                border
                cell-class-name="p-0"
                header-cell-class-name="bg-white"
                style="width: 100%;border: 1px solid rgba( 144, 12, 63 , .4)">
              <el-table-column
                  label="Fusion"
                  prop="url"
                  width="200">
                <template slot-scope="scope">
                  <vlink :text="setTableFusionServerProp(scope.row.id, 'url')"
                         :url="setTableFusionServerProp(scope.row.id, 'url')"></vlink>
                </template>
              </el-table-column>
              <el-table-column
                  :formatter="setTableFusionServerFormatter"
                  label="Password"
                  prop="password"
                  width="350">
                <template slot-scope="scope">
                  <smartInputView :customParams="{id: setTableFusionServerProp(scope.row.id, 'id')}"
                                  :inputValue="setTableFusionServerProp(scope.row.id, 'password')"
                                  :saveAction="updateFusionField"
                                  editContainerStyle="position: relative;top: 0px;" fieldName="password"
                                  inputWidth="200px"></smartInputView>
                </template>
              </el-table-column>
              <el-table-column
                  :formatter="setTableFusionServerFormatter"
                  label="Name"
                  prop="name">
              </el-table-column>
            </el-table>

            <div v-if="props.row.user_profile_id == 5 || props.row.user_profile_id == 6">
              <h6 class="app-light-silver-background mb-0 mt-2 p-2 pl-3 text-center">VOS Info</h6>
              <el-table
                  :data="[props.row]"
                  border
                  cell-class-name="p-1"
                  header-cell-class-name="bg-white"
                  style="width: 100%;border: 1px solid rgba( 50, 151, 209  , .4)">

                <el-table-column label="IP">
                  <template slot-scope="scope">
                    {{setTableVOSServerProp(scope.row.id, 'vos_ip')}}
                  </template>
                </el-table-column>

                <el-table-column label="Recharge Link">
                  <template slot-scope="scope">
                    <vlink :text="setTableVOSServerProp(scope.row.id, 'vos_recharge_link')"
                           :url="setTableVOSServerProp(scope.row.id, 'vos_recharge_link')"></vlink>
                  </template>
                </el-table-column>

                <el-table-column label="Username">
                  <template slot-scope="scope">
                    {{ setTableVOSServerProp(scope.row.id, 'vos_username') }}
                  </template>
                </el-table-column>

                <el-table-column label="Password">
                  <template slot-scope="scope">
                    {{ setTableVOSServerProp(scope.row.id, 'vos_password') }}
                  </template>
                </el-table-column>

              </el-table>
            </div>

          </div>
          <!--row-class-name="app-light-silver-background"-->


        </template>
      </el-table-column>
      <el-table-column
          label="Display"
          prop="display_name"
          sortable
          width="130">
      </el-table-column>
      <el-table-column
          label="Username"
          prop="username"
          width="130">
      </el-table-column>
      <el-table-column
          label="Profile"
          prop="profile_caption"
          width="150">
      </el-table-column>
      <el-table-column
          label="Email"
          prop="email"
          width="180">
      </el-table-column>
      <el-table-column
          label="Money"
          prop="money"
          width="80">
      </el-table-column>
      <el-table-column
          label="Consumption"
          prop="today_consumption"
          width="120">
      </el-table-column>
      <el-table-column
          label="Overdraft "
          prop="limitmoney"
          width="100">
      </el-table-column>
      <el-table-column
          label="Created"
          prop="created_at"
          width="110">
      </el-table-column>
      <el-table-column
          
          label="Action"
          width="80"
          prop="">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions" :params="{data: scope.row, rowIndex: scope.$index + 1} "
                     :userProfileId="scope.row.user_profile_id" :currentUser="currentUser"></vDropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import { getLS} from 'devegram-javascript-util';
// import voipCustomers from '../../../../modules/voip-customer/list/page/assign-customers'
import fieldController from "devegram-vue-data-collecter-eui/src/mixins/fieldController";
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  mixins: [fieldController, panelMixin],
  components: {
    voipCustomers: () => import('@/modules/voip-customer/list/page/assign-customers'),
    assignResellerList: () => import('@/modules/voip-reseller/list/page/assign-resellers-list'),
    assignVendorList: () => import('@/modules/voip-vendor/list/page/assign-vendor-list'),
    userCdrList: () => import('@/modules/voip-vos-cdr-viewer/cdr-viewer/user-cdr-viewer'),
    voipCustomerRates: () => import('@/modules/voip-customer-rate/list/page/View'),
    voipReportAnalysisStatistic: () => import('@/modules/voip-report-analysis-statistic/list/page/View'),
    topLcrDestinations: () => import('@/modules/voip-lcr-top-destinations/lcr/top-destination/page/View'),
    broadcastHistory: () => import('@/modules/voip-testing-panel/broadcast-history/page/View'),
    setProfileRateForm: () => import('@/modules/user-reseller-features/set-profit-rate/View'),
    setWorkingRates: () => import('@/modules/user-reseller-features/set-working-rates/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    smartInputView: () => import('@/components/smart-input-view/View'),
    vlink: () => import('@/components/link/View'),
    vDropdown: () => import('./button-dropdown')
  },
  data() {
    return {
      currentUser : null,
      isUserSales: $store.getters['user-state/isUserSales'],
      customerData: null,
      resellerData : null,
      vendorData : null,
      cdrData : null,
      voipReportAnalysisStatisticRateDialog: false,
      editLiveTrafficRate: false,
      reportAnalysisStatisticViewMode: 'normal',
      showOnlyFixedRates: false,
      showOnlyNewRates: false,
      userUsingPrivateRate: null,
      userRateStatus: null,
      customerRatesBoardDialog: false,
      showCustomersList: false,
      showCustomersList2: false,
      showResellerList : false,
      showVendorList : false,
      showCDRList : false,
      selectedCustomerUsername: false,
      voipReportAnalysisStatisticDialog: false,
      topLcrDialogVisibility: false,
      usersActions: [
        {
          label: 'Edit Profile',
          icon: 'el-icon-edit',
          action: 'editAction',
          borderBottom: true
        },
        {
          label: 'View Rates',
          icon: 'el-icon-view',
          action: 'openCustomerRatesBoard',
          forProfiles: [6],
        },
        {
          label: 'Live Traffic',
          icon: 'el-icon-pie-chart',
          action: 'viewReportAnalysisStatistic',
          forProfiles: [6],
        },
        {
          label: 'Live Traffic Rate',
          icon: 'el-icon-data-line',
          action: 'viewReportAnalysisStatisticRates',
          forProfiles: [6],
          borderBottom: true
        },
        {
          label: 'View Tests',
          icon: 'el-icon-view',
          action: 'viewUserTests',
        },
        {
          label: 'View LCR',
          icon: 'el-icon-s-grid',
          action: 'openTopLcrDestinationsDialog',
          notForProfiles: [12]
        },
        {
          label: 'Remove',
          icon: 'el-icon-delete',
          action: 'removeAction'
        },
        {
          label: 'Assign Customers',
          icon: 'el-icon-delete',
          action: 'openCustomersList',
          forProfiles: [9],
        },
        {
          label: 'Assign Resellers',
          icon: 'el-icon-delete',
          action: 'openResellerList',
          forProfiles: [9],
        },
        {
          label: 'Assign Vendors',
          icon: 'el-icon-delete',
          action: 'openVendorList',
          forProfiles: [16],
        },
        // {
        //   label: 'View CDR',
        //   icon: 'el-icon-delete',
        //   action: 'openCDRList',
        //   forProfiles: [6],
        // },
      ],
      tableData: [],
      control: this,
      profilesOptionsList: [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfiles],
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      currentPage: 1,
      pageChunkSize: 16,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      filterByProfileId: '',
      divisionsList: [],
      selectedUserProfileId: null,
      lcrSelectedDivision: false
    };
  },
  beforeMount() {
    if (this.isUserSales) {
      this.filterByProfileId = 6
    }
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
    this.panelMixin_getUserVoipDivision('divisionsList', () => {
    })
    this.currentUser = getLS('user').profile_id;
    if(this.currentUser == 9){
      this.profilesOptionsList = [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfilesForManager]
    }
    else if(this.currentUser == 4){

      this.profilesOptionsList = [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfilesForEmploy]

    }
    else if(this.currentUser == 15){

      this.profilesOptionsList = [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfilesForSales]

    }
    else{
      this.profilesOptionsList = [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfiles]
    }
    // this.profilesOptionsList = this.currentUser != 9 ? [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfiles] : [{label: 'None', value: ''}, ...$store.state['user-state'].usersProfilesForManager]
    // debugger 
    
  },
  methods: {
    closeDialog(){
      // debugger
      this.showCustomersList2 =false;
      this.showResellerList = false;
      this.showVendorList = false;
      this.showCDRList = false;
      this.dialogVisible =  false;
    },
    onVisible(){
     this.showCustomersList2 =false;
     this.showResellerList = false;
     this.showVendorList = false;
     this.showCDRList = false;
     this.dialogVisible = false;
    },
    tableRowClassName({row, rowIndex}) {
      if (row.email.substr(0,2) == '__') {
        return 'app-bg-gold-low-alfa';
      }
      return '';
    },
    openCustomerRatesBoard (params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = -1
      this.customerData = data
      this.userRateStatus = (this.showOnlyNewRates) ? '<span class="app-bg-gold-low-alfa pending p-2">New Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = true
      this.editLiveTrafficRate = false
      this.customerRatesBoardDialog = true
    },
    openCustomersList (params){
       let data = params.data
    this.showCustomersList = true; 
    this.showCustomersList2 = true; 
    this.customerData = data
    },
    openResellerList(params){
      this.showResellerList = true;
      this.resellerData = params.data
    },
    openVendorList(params){
      this.showVendorList = true;
      this.vendorData = params.data
    },
    openCDRList(params){
      
      this.showCDRList = true;
      this.cdrData = params.data
    },
    viewReportAnalysisStatistic (params) {
      let data = params.data
      this.selectedCustomerUsername = data.username
      this.voipReportAnalysisStatisticDialog = true
      this.reportAnalysisStatisticViewMode = 'normal'
    },
    viewReportAnalysisStatisticRates (params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = -1
      this.customerData = data
      this.userRateStatus = '<span class="voip-call-test-status p-2">Live Traffic Rates</span>'
      this.userUsingPrivateRate = true
      this.editLiveTrafficRate = true
      this.voipReportAnalysisStatisticRateDialog = true
      // this.reportAnalysisStatisticViewMode = 'edit_live_traffic_rate'
    },
    lcrDialogClosed() {
      this.lcrSelectedDivision = false
    },
    lcrDivisionUpdated(inputField) {
      let selectedDivision = inputField.field.field_value

      this.lcrSelectedDivision = false
      $vue.nextTick(() => {
        this.lcrSelectedDivision = selectedDivision
      })
    },
    openTopLcrDestinationsDialog(params) {
      this.selectedUserId = params.data.id
      this.selectedUserProfileId = params.data.user_profile_id
      this.topLcrDialogVisibility = true
    },
    updateFusionField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.id,
        data
      }

      this.updateFusionEntity(apiParams).then(r => {
        afterSave()
      })
    },
    setTableFusionServerFormatter(row, column) {
      return $store.state['user-state'].usersFusionServers[row.id][column.property]
    },
    setTableVOSServerProp(id, property) {
      return $store.state['user-state'].usersVOSserver[id][property]
    },
    setTableFusionServerProp(id, property) {
      return $store.state['user-state'].usersFusionServers[id][property]
    },
    filterByProfileUpdated(inputField) {
      this.filterByProfileId = inputField.field.field_value
      this.getEntityListData(1)
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch, profileId: this.filterByProfileId}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.tableData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
      this.getUsersFusionServer({records: response.rows}).then(response => {
        this.setStateUsers({key: 'usersFusionServers', value: response})
      })

      this.getUsersVOSserver({records: response.rows}).then(response => {
        this.setStateUsers({key: 'usersVOSserver', value: response})
      })
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('user-state', {setStateUsers: 'setState'}),
    ...$mapActions('voip-testing-panel-api', {
      getUsersFusionServer: 'getUsersFusionServer',
    }),
    ...$mapActions('user-api', {
      getEntityList: 'list',
      getUsersVOSserver: 'getUsersVOSserver',
    }),
    ...$mapActions('voip-fusion-server-api', {updateFusionEntity: 'update'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.navigateToPage(this.currentPage)
    },
    afterEdit(updatedData) {
      $vue.set(this.tableData, this.rowToEdit, updatedData)
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreateProfitPercent() {
      this.setProfitRateDialogVisible = false
    },
    afterCreate(newEntity) {
      this.dialogVisible = false;
      this.refreshGrid();
    },
    viewUserTests(params) {
      this.viewUserTestsDialogVisible = true
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
    },
    setWorkingRates(params) {
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
      this.setWorkingRatesDialogVisible = true
    },
    setProfitRate(params) {
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
      this.setProfitRateDialogVisible = true
    },
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      // this.dataToBind = null;
      this.rowToEdit = null;
    },
    editAction(params) {
      this.showPasswordField = false
      this.editMode = true

      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
    },
    removeAction(params) {
      this.$confirm('This will permanently delete this user. Continue?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
          // this.tableData.splice(params.rowIndex, 1);
          this.refreshGrid()
          this.recordsCounter -= 1;
          notify({
            type: 'success',
            title: this.$ml.get('deleted'),
          });
        })
      }).catch(() => {
      });
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>

<style>
.el-table__cell.el-table__expanded-cell {
  padding: 0;
}
</style>
